import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"trash\"><path d=\"M31.3170797,274 L43.6098239,274 L43.6098239,259.512213 L31.3170797,259.512213 L31.3170797,274 Z M35.4878322,256 L35.0213665,257.31699 L30,257.31699 L30,258.634159 L44.9269036,258.634159 L44.9269036,257.31699 L39.8711934,257.31699 L39.4389817,256 L35.4878322,256 Z\" transform=\"translate(-30 -256)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/trash.svg
// module id = 734
// module chunks = 0